import React from 'react';
import ReactGA from 'react-ga';
import { Auth } from 'aws-amplify';
import { GridLoader, MoonLoader } from 'react-spinners';
import { css } from '@emotion/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

const gridLoaderStyle = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
`;

const moonLoaderStyle = css`
  box-sizing: content-box;
`;

const regSpaceRemove = new RegExp(/ +?/g);

function getOsName(deviceObj) {
  if (deviceObj.isMobile) {
    return deviceObj.os;
  } else {
    return deviceObj.osName;
  }
}
function getBrowserName(deviceObj) {
  let browserName = '';

  if (deviceObj.isMobile || deviceObj.isTablet) {
    console.log('Device......', deviceObj);
    let isOpera =
      navigator.userAgent.indexOf('Opera') ||
      navigator.userAgent.indexOf('OPR') !== -1;
    console.log('isOpera......', isOpera);

    let isFirefox = navigator.userAgent.indexOf('Firefox') !== -1;

    console.log('isFirefox......', isFirefox);

    let isSafari = navigator.userAgent.indexOf('Safari') !== -1;

    console.log('isSafari......', isSafari);

    let isIE =
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      navigator.userAgent.indexOf('rv:') > -1 ||
      !!document.documentMode === true;

    console.log('isIE......', isIE);

    // Edge 20+
    var isEdge =
      navigator.userAgent.indexOf('Edg') !== -1 ||
      navigator.userAgent.indexOf('edg') !== -1;

    console.log('isEdge...........', isEdge);

    // Chrome 1 - 71
    var isChrome = navigator.userAgent.indexOf('Chrome') !== -1;

    console.log('isChrome...........', isChrome);

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    if (isFirefox) {
      browserName = 'FireFox';
    } else if (isChrome) {
      browserName = 'Chrome';
    } else if (isSafari) {
      browserName = 'Safari';
    } else if (isOpera) {
      browserName = 'Opera';
    } else if (isIE) {
      browserName = 'IE';
    } else if (isEdge) {
      browserName = 'Edge';
    }
  } else {
    browserName = deviceObj.browserName;
  }
  return browserName;
}

/**
 * Validate email address and return true or false
 * @param {*} email Email address
 */
function validateEmail(email) {
  let emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRegExp.test(email.toLowerCase())) {
    return true;
  } else {
    return false;
  }
}
/**
 * Track goole analtytic page view
 */
function pageView() {
  ReactGA.pageview(window.location.pathname + window.location.search);
}

/**
 * Get refresh token from congnito before calling api, if token expired it will return new token
 * @param {*} cb : Call back function return error or token
 */
function getToken(cb) {
  Auth.currentSession()
    .then((session) => {
      console.log(session);
      const token = session.idToken.jwtToken;
      cb(null, token);
    })
    .catch((e) => {
      console.log('e...............wwww', e);
      cb(e);
    });
}
/**
 * Hand api response and parse data to json
 * @param {*} response
 */
// function handleResponse(response) {
//   // console.log('response....', response)
//   return response.text().then((text) => {
//     // console.log('text....', text)
//     const data = text && JSON.parse(text);
//     // console.log('data...', data)
//     if (!response.ok) {
//       console.log('ok1');
//       if (response.status === 401) {
//         console.log('ok2');
//         window.location.reload();
//       }
//       const error = (data && data.message) || response.statusText;
//       return Promise.reject(error);
//     }
//     return data;
//   });
// }

function handleResponse(response) {
  // console.log('response....', response)
  return response.text().then((text) => {
    // console.log('text....', text)
    const data = text && JSON.parse(text);
    // console.log('data...', data)
    if (!response.ok) {
      console.log('ok1', response.status);
      if (response.status === 504 || response.status === 502) {
        console.log('e....', response.message);
        return Promise.reject({
          status: response.status,
          message: data.message,
        });
      }
      if (response.status === 400) {
        return Promise.reject({
          status: response.status,
          message: data.responceObject.userMessage,
        });
      }
      if (response.status === 401) {
        // console.log('ok2')
        window.location.reload();
        return Promise.reject(data);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function htmlDecode(content) {
  const parser = new DOMParser();
  const parsedHTML = parser.parseFromString(content, 'text/html');
  return parsedHTML.body.innerHTML;
}

/**
 *
 * @param {object (node)} newNode
 * @param {object (node)} referenceNode
 */
function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function getTileColorCodeFromIndex(colorArr, index) {
  if (colorArr.length) {
    return colorArr[index % colorArr.length];
  }
  return '';
}
function getGoogleDriveUrlId(url) {
  var id = '';
  var parts = url.split(
    /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/
  );
  if (url.indexOf('?id=') >= 0) {
    id = parts[6].split('=')[1].replace('&usp', '');
    return id;
  } else {
    id = parts[5].split('/');
    //Using sort to get the id as it is the longest element.
    var sortArr = id.sort(function (a, b) {
      return b.length - a.length;
    });
    id = sortArr[0];
    return id;
  }
}

const loaderColor = '#cadb2a';
function GridSweetLoader(props) {
  return (
    <div className="sweet-loading">
      <GridLoader
        css={props.css}
        sizeUnit={props.sizeUnit}
        size={props.size}
        color={props.color}
        loading={props.loading}
      />
    </div>
  );
}

GridSweetLoader.propTypes = {
  loading: PropTypes.bool,
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sizeUnit: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
};

GridSweetLoader.defaultProps = {
  loading: false,
  css: gridLoaderStyle,
  sizeUnit: 'px',
  size: 40,
  color: loaderColor,
};

const colorMap = {
  pear: {
    'borderColor': '#ffffff',
    'borderBottomColor': '#8c991a',
  },
};
function BorderSpinner({ loading, size, color }) {
  let spinnerStyle = null;
  if (color !== '') {
    spinnerStyle = {
      ...colorMap[color],
    };
  }

  if (size !== '') {
    spinnerStyle['width'] = `${size}em`;
    spinnerStyle['height'] = `${size}em`;
  }
  return (
    <span
      className={cx('loader-border-spinner', {
        'd-inline-block': loading,
        'd-none': !loading,
      })}
      style={spinnerStyle}
    />
  );
  /* return (
    <MoonLoader
      css={css}
      sizeUnit={sizeUnit}
      size={size}
      color={color}
      loading={loading}
    />
  ); */
}
BorderSpinner.propTypes = {
  loading: PropTypes.bool,
  // css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // sizeUnit: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
};

BorderSpinner.defaultProps = {
  loading: false,
  /* css: moonLoaderStyle,
  sizeUnit: 'px', */
  size: '',
  color: '',
};

const hasWindow = typeof window !== 'undefined' ? window : null;

const windowSizeBreakpoints = {
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
  xs: 0,
};

/**
 * Breakpoint name is based on Bootstrap framework
 * @param {number} width
 */
function getWindowBreakpointName(width) {
  return Object.keys(utilService.windowSizeBreakpoints).find((breakpoint) => {
    if (width >= utilService.windowSizeBreakpoints[breakpoint]) {
      return breakpoint;
    }
  });
}

/**
 *
 * Window breakpoints are described as per Bootstrap framework media queries
 * xl = 1200px
 * lg = 992px
 * md = 768px
 * sm = 575px
 *
 * @param {string} breakpoint
 */
function checkWindowWidth(breakpoint) {
  if (hasWindow) {
    const breakpointValue = breakpoint.type
      ? breakpoint.currentTarget.params
      : breakpoint;
    return hasWindow.matchMedia(
      `(min-width: ${windowSizeBreakpoints[breakpointValue]}px)`
    ).matches;
  }
  return false;
}

// Hook
function useWindowSize(breakpoint = '') {
  // if hook will have any breakpoint parameter
  // then will return true/false based on requested check breakpoints
  // Initialize state with undefined width/height so server and client renders match
  const [windowSize, setWindowSize] = React.useState({
    width: undefined,
    height: undefined,
  });

  React.useEffect(() => {
    // Handler to call on window resize

    function handleResize() {
      if (breakpoint !== '') {
        setWindowSize(checkWindowWidth(breakpoint));
      } else {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
    }

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

export const utilService = {
  regSpaceRemove,
  gridLoaderStyle,
  loaderColor,
  GridSweetLoader,
  BorderSpinner,
  getBrowserName,
  getOsName,
  validateEmail,
  pageView,
  getToken,
  handleResponse,
  htmlDecode,
  insertAfter,
  getTileColorCodeFromIndex,
  getGoogleDriveUrlId,
  windowSizeBreakpoints,
  getWindowBreakpointName,
  checkWindowWidth,
  useWindowSize,
};